class FarloUiTicketCalendar {
	constructor(element, _config) {
		this.container = element;
		this.options = _config;
		this.minDate = new Date(this.container.dataset.startMonth);
		this.maxDate = new Date(this.container.dataset.endMonth);
		this.today = new Date();
		this.currentDate = new Date();
		
		this.render = this.render.bind(this);
		this.renderHeader = this.renderHeader.bind(this);
		this.renderDaysOfTheWeeks = this.renderDaysOfTheWeeks.bind(this);
		this.fetchEventsForMonth = this.fetchEventsForMonth.bind(this);

		this.render();
	}

	async render() {
		// [1] Removed auto-skip logic:
		// const hasEventsInCurrentMonth = await this.checkForEventsInMonth(
		//    this.currentDate.getFullYear(),
		//    this.currentDate.getMonth() + 1
		// );
		// if (!hasEventsInCurrentMonth) {
		//     await this.loadFirstFutureMonthWithEvents();
		// }

		const daysContainer = this.container.querySelector('.site-farlo-ui-ticket-calendar__days');
		if (daysContainer) {
			daysContainer.innerHTML = '';
		}

		this.renderHeader(); 
		this.renderDaysOfTheWeeks();

		await this.fetchEventsForMonth(
			this.currentDate.getFullYear(),
			this.currentDate.getMonth() + 1
		);

		let availabilitySection = this.container.querySelector('.site-farlo-ui-ticket-calendar__availability');
		if (!availabilitySection) {
			availabilitySection = document.createElement('div');
			availabilitySection.classList.add('site-farlo-ui-ticket-calendar__availability');

			const availabilityOptions = [
				{ text: 'Available', className: 'availability__available' },
				{ text: 'Selling Fast', className: 'availability__selling-fast' },
				{ text: 'Last Few', className: 'availability__last-few' },
				{ text: 'Sold Out', className: 'availability__sold-out' }
			];
			
			availabilityOptions.forEach(option => {
				const span = document.createElement('span');
				span.classList.add('availability', option.className);
				span.textContent = option.text;
				availabilitySection.appendChild(span);
			});

			const header = this.container.querySelector('.site-farlo-ui-ticket-calendar__header');
			this.container.insertBefore(availabilitySection, header.nextSibling);
		}
	}

	async checkForEventsInMonth(year, month) {
		const response = await this.fetchEventsForMonth(year, month);
		return (
			response &&
			response.data &&
			response.data.calendarCells &&
			response.data.calendarCells.length > 0
		);
	}

	// [2] This method is unused if you've removed the auto-skip logic entirely
	async loadFirstFutureMonthWithEvents() {
		let nextMonth = new Date(this.currentDate);

		while (nextMonth <= this.maxDate) {
			const hasEvents = await this.checkForEventsInMonth(
				nextMonth.getFullYear(),
				nextMonth.getMonth() + 1
			);
			if (hasEvents) {
				this.currentDate = nextMonth;
				break;
			}
			nextMonth.setMonth(nextMonth.getMonth() + 1);
		}
	}

	async fetchEventsForMonth(y, m) {
		let data = {};
	
		if (typeof farloAjaxVendorHandler.apiKey !== 'undefined' && farloAjaxVendorHandler.apiKey !== '') {
			data = new URLSearchParams({
				action: 'getEventsFromApi',
				nonce: farloAjaxVendorHandler.nonce,
				month: m,
				year: y
			});
		} else {
			data = new URLSearchParams({
				action: 'getEventsForMonth',
				nonce: farloAjaxVendorHandler.nonce,
				month: m,
				year: y
			});
		}
	
		this.container.classList.add('site-farlo-ui-ticket-calendar--loading');
	
		try {
			const response = await fetch(farloAjaxVendorHandler.ajaxurl, {
				method: 'POST',
				body: data,
				headers: {
					'Accept': 'application/json',
					'Content-type': 'application/x-www-form-urlencoded',
					'X-WP-Nonce': farloAjaxVendorHandler.nonce
				}
			});
	
			if (response.ok) {
				const responseData = await response.json();
				this.container.classList.remove('site-farlo-ui-ticket-calendar--loading');
	
				this.container.innerHTML = ''; // Clear existing content
				this.renderHeader(); 
				this.renderDaysOfTheWeeks(); 
	
				if (
					typeof responseData.data.calendarCells !== 'undefined' &&
					responseData.data.calendarCells !== ''
				) {
					let calendarHtml = responseData.data.calendarCells;
	
					const tempContainer = document.createElement('div');
					tempContainer.innerHTML = calendarHtml;
	
					const today = new Date();
					today.setHours(0, 0, 0, 0);
	
					const days = tempContainer.querySelectorAll('.site-farlo-ui-ticket-calendar__days-day');
					days.forEach(day => {
						const dayDateStr = day.getAttribute('rel');
						if (dayDateStr) {
							const dayDate = new Date(dayDateStr);
							dayDate.setHours(0, 0, 0, 0);
	
							if (dayDate < today) {
								const links = day.querySelectorAll('a.site-farlo-ui-ticket-calendar__days-link');
								links.forEach(link => {
									link.removeAttribute('href');
									link.style.pointerEvents = 'none';
									link.classList.add('sold-out');
								});
							}
						}
					});
	
					this.container.insertAdjacentHTML('beforeend', tempContainer.innerHTML);
				}
	
				return responseData;
			} else {
				console.error('Response status not OK:', response.status);
			}
		} catch (error) {
			console.error('There was an error!', error);
		}
	}
	
	renderHeader() {
		const header = document.createElement('div');
		header.classList.add('site-farlo-ui-ticket-calendar__header');

		const prevButton = document.createElement('button');
		prevButton.classList.add('site-farlo-ui-ticket-calendar__button', 'site-farlo-ui-ticket-calendar__button--prev');
		prevButton.innerHTML = `<span><svg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
								<path d='M6.69825 1L1 6.69825L6.69825 12.3965M1.79142 6.69825L13.3462 6.69825' stroke='#A60093' stroke-width='1.89942' stroke-linecap='round' stroke-linejoin='round'/>
								</svg></span>`;

		if (
			parseInt(this.currentDate.getFullYear().toString() + this.currentDate.getMonth().toString(), 10) >
			parseInt(this.minDate.getFullYear().toString() + this.minDate.getMonth().toString(), 10)
		) {
			prevButton.classList.remove('site-farlo-ui-ticket-calendar__button-disabled');
			prevButton.addEventListener('click', () => this.prevMonth());
		} else {
			prevButton.classList.add('site-farlo-ui-ticket-calendar__button-disabled');
		}

		header.appendChild(prevButton);

		const title = document.createElement('h2');
		title.classList.add('site-farlo-ui-ticket-calendar__header-month-year');
		title.textContent = this.currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
		header.appendChild(title);

		const nextButton = document.createElement('button');
		nextButton.classList.add('site-farlo-ui-ticket-calendar__button', 'site-farlo-ui-ticket-calendar__button--next');
		nextButton.innerHTML = `<span><svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M8.30175 12.6934L14 6.99511L8.30175 1.29685M13.2086 6.99511L1.65379 6.99511" stroke="#A60093" stroke-width="1.89942" stroke-linecap="round" stroke-linejoin="round"/>
								</svg></span>`;

		if (
			parseInt(this.currentDate.getFullYear().toString() + this.currentDate.getMonth().toString(), 10) <
			parseInt(this.maxDate.getFullYear().toString() + this.maxDate.getMonth().toString(), 10)
		) {
			nextButton.classList.remove('site-farlo-ui-ticket-calendar__button-disabled');
			nextButton.addEventListener('click', () => this.nextMonth());
		} else {
			nextButton.classList.remove('site-farlo-ui-ticket-calendar__button-disabled');
			nextButton.addEventListener('click', () => this.nextMonth());
		}

		header.appendChild(nextButton);

		this.container.appendChild(header);
	}

	renderDaysOfTheWeeks() {
		const div = document.createElement('div');
		div.classList.add('site-farlo-ui-ticket-calendar__weeks');
		const daysLetters = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

		for (let i = 0; i < 7; i += 1) {
			const days = document.createElement('div');
			days.classList.add('site-farlo-ui-ticket-calendar__week-day');
			days.textContent = daysLetters[i];
			div.appendChild(days);
		}

		this.container.appendChild(div);
	}

	// [3] FIX the date rollover by forcing day = 1
	prevMonth() {
		this.currentDate.setDate(1);
		this.currentDate.setMonth(this.currentDate.getMonth() - 1);
		this.render();
	}

	nextMonth() {
		this.currentDate.setDate(1);
		this.currentDate.setMonth(this.currentDate.getMonth() + 1);
		this.render();
	}

	handleEventClick(event) {
		if (this.options.eventClick) {
			this.options.eventClick(event);
		}
	}
}

HTMLDivElement.prototype.farloUiTicketCalendar = function(settings) {
	return new FarloUiTicketCalendar(this, settings);
};
